import './App.css';
import { DashboardProvider } from './context/DashboardContext';
import DashboardShell from './components/DashboardShell';
import fcpPilot from './config/orgs/fcp-pilot';

// Add more org configs here as new deployments are created.
const CONFIGS = {
  'fcp-pilot': fcpPilot
};

const activeConfig = CONFIGS[process.env.REACT_APP_ORG] ?? fcpPilot;

export default function App() {
  return (
    <DashboardProvider config={activeConfig}>
      <DashboardShell />
    </DashboardProvider>
  );
}
